import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class TechnicalZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.fiscalization.validation.technical-zero.error');
    }
}
